import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListWeightLots from './ListWeightLots.js';
import AddWeightLot from './AddWeightLot.js';
import Upload from '../../shared/Upload.js';
import WhatsAppTip from '../../shared/WhatsAppTip.js';
import { weightLotTips } from '../../shared/whatsappTips.js';
import { ListButton, AddButton, UploadButton, DownloadButton, FAB } from '../../shared/ActionButtons';

// Data model for CSV upload
const weightLotDataModel = [
  { field: 'name',          type: 'string', descriptionKey: 'weight_lot_name',   required: false },
  { field: 'mlw',           type: 'number', descriptionKey: 'median_lot_weight', range: [1, 9999],   required: true },
  { field: 'target_weight', type: 'number', descriptionKey: 'lot_target_weight', range: [100, 1200], required: false },
  { field: 'created_at',    type: 'date',   descriptionKey: 'lot_created_at',    required: false },
];

// Exported action buttons for use in Weight hub header
export const WeightLotsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton   isActive={screen === 'list'}   onClick={() => setScreen('list')} />
    <AddButton    isActive={screen === 'add'}    onClick={() => setScreen('add')} />
    <UploadButton isActive={screen === 'upload'} onClick={() => setScreen('upload')} />
    <DownloadButton collection="lots" />
  </div>
);

const formatCode = (lotId, prefix) =>
  lotId != null ? `${prefix}-${String(lotId).padStart(4, '0')}` : '';

export const WeightLots = ({ screen, setScreen, actions }) => {
  const { t } = useTranslation();
  const [localScreen, setLocalScreen] = useState('list');
  const [listKey,     setListKey]     = useState(0);
  const [tip,         setTip]         = useState(null); // { title, tips }

  const currentScreen    = screen    !== undefined ? screen    : localScreen;
  const setCurrentScreen = setScreen !== undefined ? setScreen : setLocalScreen;

  const handleCreated = (lot) => {
    setCurrentScreen('list');
    setListKey(k => k + 1);
    const code = formatCode(lot?.lot_id, t('weight_lot_prefix'));
    if (code) {
      setTip({ title: `✅ ${code} ${t('created')}`, tips: weightLotTips(code, lot?.weight?.tracking_method, t) });
    }
  };

  const handleDefaultSet = (lot) => {
    const code = formatCode(lot?.lot_id, t('weight_lot_prefix'));
    if (code) {
      setTip({
        title: `★ ${t('wat_default_set')}: ${code}`,
        tips: [
          { label: t('wat_shorthand'),  message: `1234 285kg` },
          { label: t('wat_query_lot'),  message: code },
        ],
      });
    }
  };

  return (
    <>
      {actions && <div className="content-header">{actions}</div>}
      {currentScreen === 'list' && (
        <>
          {tip && (
            <WhatsAppTip
              title={tip.title}
              tips={tip.tips}
              onDismiss={() => setTip(null)}
            />
          )}
          <ListWeightLots refreshKey={listKey} onDefaultSet={handleDefaultSet} />
          <FAB onClick={() => setCurrentScreen('add')} />
        </>
      )}
      {currentScreen === 'add' && (
        <AddWeightLot onSuccess={handleCreated} />
      )}
      {currentScreen === 'upload' && (
        <Upload
          collection="lots"
          dataModel={weightLotDataModel}
          onSuccess={() => setCurrentScreen('list')}
        />
      )}
    </>
  );
};

export default WeightLots;
